import { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [packageNotFound, setPackageNotFound] = useState(false);

  return (
    <GlobalContext.Provider value={{ packageNotFound, setPackageNotFound }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);
